const UNKNOWN_ERROR = 'Unknown error'

interface IJSendFailure {
  messages?: unknown[]
  message?: string
  error?: unknown
}

interface IJSendFieldError {
  field?: string
  message: string
}

interface IJSendResponse {
  status: string
  data?: unknown
  message?: string
}

const failureOf = (data: unknown): IJSendFailure =>
  Array.isArray(data) ? { error: data } : ((data ?? {}) as IJSendFailure)

const toMessage = (item: unknown): string => {
  if (typeof item === 'string') {
    return item
  }

  const message = (item as { message?: unknown } | null)?.message

  return typeof message === 'string' ? message : JSON.stringify(item)
}

const isFieldError = (item: unknown): item is IJSendFieldError =>
  typeof (item as IJSendFieldError | null)?.message === 'string'

export const getJSendErrorMessages = (response: IJSendResponse): string[] => {
  if (response.status === 'success') {
    return []
  }

  if (response.status === 'fail') {
    const { messages, message, error } = failureOf(response.data)

    if (messages?.length) {
      return messages.map(toMessage)
    }

    if (Array.isArray(error)) {
      if (error.length) {
        return error.map(toMessage)
      }
    } else if (error) {
      return [toMessage(error)]
    }

    if (message) {
      return [message]
    }
  }

  return [response.message || UNKNOWN_ERROR]
}

export const getJSendFieldErrors = (response: IJSendResponse): IJSendFieldError[] => {
  if (response.status !== 'fail') {
    return []
  }

  const { error } = failureOf(response.data)

  return Array.isArray(error) ? error.filter(isFieldError) : []
}
